/**
 * Shared react-query key for collection member list data.
 * Keep this centralized so query + invalidation paths stay in sync.
 */
export function collectionMembersQueryKey(collectionId) {
    return ["collection.members", collectionId];
}
/** Effective ACL (direct + inherited) — use for attribution on nested collections. */
export function collectionEffectiveMembersQueryKey(collectionId) {
    return ["collection.effectiveMembers", collectionId];
}
